function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  y: 135.23,
  fill: "#F9DBED",
  width: 77.896,
  height: 84.77
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 11.457,
  y: 150.123,
  fill: "#92C5C9",
  width: 54.984,
  height: 54.984
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 77.896,
  y: 135.23,
  fill: "#E76DB6",
  width: 32.074,
  height: 84.77
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#C8E2E4",
  points: "11.457,205.107 25.203,205.107 66.441,150.123 52.695,150.123 "
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ADD4D7",
  points: "25.203,205.107 38.949,205.107 66.441,168.45 66.441,150.123 "
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#77B7BC",
  points: "38.949,205.107 52.695,205.107 66.441,186.778 66.441,168.45 "
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#929292",
  points: "65.152,134.058 113.316,134.058 135.191,0 87.027,0 "
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "117.639,220 109.723,220 191.438,110.332 195.459,115.72  "
}));

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "191.438,220 113.623,115.72 117.639,110.332 199.557,220  "
}));

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "148.93,220 140.896,220 222.725,110.332 226.744,115.72  "
}));

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "222.725,220 144.902,115.72 148.93,110.332 230.963,220  "
}));

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 86.803,
  fill: "#FFFFFF",
  width: 118.025,
  height: 118.026
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 204.828,
  fill: "#3B3835",
  width: 48.164,
  height: 118.026
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#CCCCCC",
  points: "274.867,134.058 226.701,134.058 204.828,0 252.992,0 "
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 98.648,
  y: 95.872,
  fill: "#929292",
  width: 93.66,
  height: 11.275
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 144.902,
  y: 10.744,
  fill: "#929292",
  width: 47.406,
  height: 5.639
});

var SvgQueEsObs01 = function SvgQueEsObs01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "275px",
    height: "220px",
    viewBox: "0 0 275 220",
    enableBackground: "new 0 0 275 220",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_01.eeb63c71.svg";
export { ForwardRef as ReactComponent };